import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Audiences } from "../components/Audiences";
import { Partners } from "../components/Partners";
import { Protocol } from "../components/Protocol";
import { Services } from "../components/Services";
import { CinematicBreak } from "../components/CinematicBreak";
import { Portfolio } from "../components/Portfolio";
import { CaseStudy } from "../components/CaseStudy";
import { Testimonials } from "../components/Testimonials";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash;
      const scrollToEl = (behavior) => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior, block: "start" });
      };
      // Multiple attempts to correct for layout shifts as lazy images load,
      // so we reliably land on the target section (e.g. #contact from other pages).
      const timers = [
        setTimeout(() => scrollToEl("smooth"), 350),
        setTimeout(() => scrollToEl("auto"), 900),
        setTimeout(() => scrollToEl("auto"), 1600),
      ];
      return () => timers.forEach(clearTimeout);
    }
  }, [location]);

  return (
    <main className="bg-[#F1EEE8] text-[#232326] min-h-screen" data-testid="home-page">
      <Nav />
      <Hero />
      <About />
      <Audiences />
      <Partners />
      <Protocol />
      <Services />
      <CinematicBreak />
      <Portfolio />
      <CaseStudy />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
